import axios from 'axios';
import CONFIG from '../config';
const api = axios.create({ baseURL: CONFIG.API_BASE_URL });
api.interceptors.request.use(c => { const t = localStorage.getItem('access_token'); if (t) c.headers.Authorization = 'Bearer ' + t; return c; });
api.interceptors.response.use(r => r, async err => {
  const isLoginRequest = err.config?.url && (err.config.url.includes('/auth/login') || err.config.url.includes('/login'));

  if (err.response?.status === 401 && !isLoginRequest) {
    if (!err.config._retry) {
      err.config._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const { data } = await axios.post(CONFIG.API_BASE_URL + '/auth/refresh/', { refresh: refreshToken });
          localStorage.setItem('access_token', data.access);
          err.config.headers.Authorization = 'Bearer ' + data.access;
          return api(err.config);
        } catch (refreshErr) {
          localStorage.clear();
          window.location.href = '/login?expired=true';
          return Promise.reject(refreshErr);
        }
      } else {
        localStorage.clear();
        window.location.href = '/login?expired=true';
      }
    } else {
      localStorage.clear();
      window.location.href = '/login?expired=true';
    }
  }
  return Promise.reject(err);
});
// Auth
export const login = (payload) => api.post('/auth/login/', payload);
export const getInit = () => api.get('/auth/init/');
// Ingestion
export const triggerSemsFetch = d => api.post('/ingestion/sems/fetch/', d);
export const uploadTradingData = d => api.post('/ingestion/trading/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const uploadMarketData = d => api.post('/ingestion/market/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const triggerTradingIngest = d => api.post('/ingestion/trading/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const triggerMarketIngest = d => api.post('/ingestion/market/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const triggerObligationIngest = d => api.post('/ingestion/obligation/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const triggerForecastIngest = d => api.post('/ingestion/forecast/upload/', d, { headers: { 'Content-Type': 'multipart/form-data' } });
export const getIngestionHealth = () => api.get('/ingestion/status/health/');
export const getIngestionStatus = p => api.get('/ingestion/status/', { params: p });
// NEW: APPCL API integration
export const triggerAppcl = d => api.post('/ingestion/appcl/fetch/', d);
// NEW: Manikaran push (for testing from frontend)
export const pushManikaranData = d => api.post('/ingestion/manikaran/push/', d);
// Dashboards
export const getExecutiveSummary = p => api.get('/dashboards/executive-summary/', { params: p });
export const getForecastVsActual = p => api.get('/dashboards/forecast-vs-actual/', { params: p });
export const getTradingDashboard = p => api.get('/dashboards/trading-dashboard/', { params: p });
export const getPriceAnalysis = p => api.get('/dashboards/price-analysis/', { params: p });
export const getRevenuePerformance = p => api.get('/dashboards/revenue-performance/', { params: p });
export const getDsmHeatmap = p => api.get('/dashboards/dsm-heatmap/', { params: p });
export const getCufAvailability = p => api.get('/dashboards/cuf-availability/', { params: p });
export const getTimeBlockHeatmap = p => api.get('/dashboards/timeblock-heatmap/', { params: p });
export const getMarketBenchmarking = p => api.get('/dashboards/market-benchmarking/', { params: p });
export const getMonthlySummary = p => api.get('/dashboards/monthly-summary/', { params: p });
export const getPlantComparison = p => api.get('/dashboards/plant-comparison/', { params: p });
export const getEnergySegregation = p => api.get('/dashboards/energy-segregation/', { params: p });
export const getDataQuality = p => api.get('/dashboards/data-quality/', { params: p });
// Trading data queries
export const getTimeblocks = p => api.get('/trading/timeblocks/', { params: p });
export const getGeneration = p => api.get('/trading/generation/', { params: p });
export const getTradingMasterData = p => api.get('/trading/trading-master-data/', { params: p });
// Master
export const getPlants = () => api.get('/core/plants/');
export const updatePlant = (id, d) => api.patch(`/core/plants/${id}/`, d);
export const getContracts = p => api.get('/core/contracts/', { params: p });

// NEW Dashboard APIs
export const getRevenueAnalysis = p => api.get('/core/dashboard/revenue-data/', { params: p });
export const getForecastTable = p => api.get('/dashboards/forecast-table/', { params: p });
export const getMarketDashboard = p => api.get('/core/dashboard/exchange-data/', { params: p });
export const getVolumeDashboard = p => api.get('/core/dashboard/volume-data/', { params: p });
export const getDsmPenalty = p => api.get('/core/dashboard/dsm-penalty/', { params: p });
export const getMarketSnapshot = p => api.get('/core/dashboard/market-snapshot/', { params: p });
export const getExplorerUnified = p => api.get('/core/dashboard/explorer-unified/', { params: p });
export const getMLGDAMAllocation = p => api.get('/core/dashboard/ml-gdam-allocation/', { params: p });
export const getGDAMOverrideRules = p => api.get('/core/dashboard/allocation-override-rules/', { params: p });
export const saveGDAMOverrideRules = d => api.post('/core/dashboard/allocation-override-rules/', d);
export const getGDAMBidPriceOverrideRules = p => api.get('/core/dashboard/bidprice-override-rules/', { params: p });
export const saveGDAMBidPriceOverrideRules = d => api.post('/core/dashboard/bidprice-override-rules/', d);
export const getWhatIfAllocationRules = p => api.get('/core/dashboard/whatif-allocation-rules/', { params: p });
export const saveWhatIfAllocationRules = d => api.post('/core/dashboard/whatif-allocation-rules/', d);
export const getWhatIfBookmarks = p => api.get('/core/dashboard/whatif-bookmarks/', { params: p });
export const saveWhatIfBookmark = d => api.post('/core/dashboard/whatif-bookmarks/', d);
export const deleteWhatIfBookmark = p => api.delete('/core/dashboard/whatif-bookmarks/', { params: p });
export const getGDAMAllocationAnalysis = d => api.post('/core/dashboard/allocation-analysis/', d);
export const getMonthlyReport = p => api.get('/core/monthly-report/', { params: p });
export const saveMonthlyReport = d => api.post('/core/monthly-report/', d);
export const submitScenarioBids = d => api.post('/core/dashboard/submit-scenario-bids/', d);
export const getBidSubmissionHistory = p => api.get('/core/dashboard/bid-submission-history/', { params: p });
export const getMonthlyReportSummary = p => api.get('/core/dashboard/monthly-report-summary/', { params: p });
export const getTotalOutageYTD = p => api.get('/core/dashboard/total-outage-ytd/', { params: p });
export const getPeakDemandMetYTD = p => api.get('/core/dashboard/peak-demand-met-ytd/', { params: p });
export const getRenewableEnergyYTD = p => api.get('/core/dashboard/renewable-energy-ytd/', { params: p });
export const getCoalStockActualVsNormative = p => api.get('/core/dashboard/coal-stock-actual-vs-normative/', { params: p });
export const getPresentReservoirLevels = p => api.get('/core/dashboard/present-reservoir-levels/', { params: p });
export const getMonthlySolarNonSolarMcp = p => api.get('/core/dashboard/solar-non-solar-mcp/', { params: p });

// User Management APIs
export const getUsers = () => api.get('/auth/users/');
export const createUser = d => api.post('/auth/users/', d);
export const updateUser = (id, d) => api.patch(`/auth/users/${id}/`, d);
export const deleteUser = id => api.delete(`/auth/users/${id}/`);

export default api;
